import { V1_REQUEST_USER } from '../../actions/users/v1requestUser'
import { V1_RECEIVE_USER } from '../../actions/users/v1receiveUser'
import { V1_REQUEST_CHANGE_USER_CUSTOM_TOP_CODE } from '../../actions/users/v1requestChangeUserCustomTOPCode'
import { V1_SET_USER_CUSTOM_TOP_CODE_FROM_SESSION_STORE } from '../../actions/users/v1setUserCustomTOPCodeFromSessionStore'
import { V1_SET_USER_HAS_CUSTOM_TOUR_OPERATOR_OVERWRITE } from '../../actions/users/v1setUserHasCustomTourOperatorOverwrite'

export const initialState = {
  isFetching: false,
  firstName: '',
  lastName: '',
  topCode: '',
  customTOPCode: '',
  roles: [],
  hasCustomTourOperatorOverwrite: false,
}

function ssr(state = initialState, action = {}) {
  switch (action.type) {
    case V1_REQUEST_USER:
      return {
        ...state,
        isFetching: true,
      }
    case V1_RECEIVE_USER:
      return {
        ...state,
        isFetching: false,
        firstName: action.data.firstName,
        lastName: action.data.lastName,
        topCode: action.data.topCode,
        roles: action.data.roles,
      }
    case V1_REQUEST_CHANGE_USER_CUSTOM_TOP_CODE:
    case V1_SET_USER_CUSTOM_TOP_CODE_FROM_SESSION_STORE:
      return {
        ...state,
        customTOPCode: action.data,
      }
    case V1_SET_USER_HAS_CUSTOM_TOUR_OPERATOR_OVERWRITE:
      return {
        ...state,
        hasCustomTourOperatorOverwrite: action.data,
      }
    default:
      return state
  }
}

export default ssr
